import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-dc4d3a76"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-container"
};
const _hoisted_2 = {
  class: "search-container"
};
const _hoisted_3 = {
  class: "search-left"
};
const _hoisted_4 = {
  class: "table-container-wrapper"
};
const _hoisted_5 = {
  class: "table-top-flex"
};
const _hoisted_6 = {
  class: "table-title"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "历史记录", -1));
const _hoisted_8 = {
  key: 0,
  class: "history-records-container"
};
const _hoisted_9 = {
  class: "records-list"
};
const _hoisted_10 = {
  class: "record-header"
};
const _hoisted_11 = {
  class: "record-time"
};
const _hoisted_12 = {
  class: "record-operator"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "operator-label"
}, "处理人：", -1));
const _hoisted_14 = {
  class: "operator-name"
};
const _hoisted_15 = {
  class: "record-content"
};
const _hoisted_16 = {
  class: "record-item"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "处理结果:", -1));
const _hoisted_18 = {
  class: "item-value"
};
const _hoisted_19 = {
  class: "record-item"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "处理意见:", -1));
const _hoisted_21 = {
  class: "item-value"
};
const _hoisted_22 = {
  key: 0,
  class: "record-images"
};
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "item-label"
}, "现场图片:", -1));
const _hoisted_24 = {
  class: "images-grid"
};
const _hoisted_25 = {
  key: 1,
  class: "no-records"
};
import moment from "moment";
import { reactive, watch, ref, onMounted, nextTick, computed } from "vue";
import { weChatrequest } from '@/utils/request';
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { ElMessage, ElMessageBox } from 'element-plus';
import { download } from "@/utils/index";
const __default__ = {
  name: "alarm-monitor-real"
};
export default /*#__PURE__*/Object.assign(__default__, {
  setup(__props) {
    const store = useStore();
    const router = useRouter();

    // 获取用户类型
    const userType = store.state.common.userInfo.userType;

    // 表格标题
    const tableTitle = computed(() => {
      const route = router.currentRoute.value;
      return route.meta?.title || route.name || '历史告警';
    });

    // 菜单图标
    const menuIcon = computed(() => {
      const route = router.currentRoute.value;
      let icon = route.meta?.icon || '';
      console.log('icon123', icon, 'route123', route);
      // 移除可能存在的 icon- 前缀
      if (icon && icon.startsWith('icon-')) {
        icon = icon.replace('icon-', '');
      }
      return icon;
    });
    let lastOccurStartTime = moment().subtract(6, "days").format("YYYY-MM-DD") + " 00:00:00";
    let lastOccurEndTime = moment().format("YYYY-MM-DD") + " 23:59:59";
    // 获取图片URL前缀
    const getImgUrl = url => {
      if (!url) return '';
      const prefix = window.g?.imgUrlPrex || '';
      return prefix + url;
    };
    const state = reactive({
      split: 0.13,
      defaultProps: {
        label: "name",
        children: "children"
      },
      treeData: [],
      defaultCheckNode: [],
      defaultExendNode: [],
      currentNodeKey: '',
      tableData: {
        rows: [],
        total: 0
      },
      openHistoryRecords: false,
      historyRecords: [],
      buttonsList: [{
        buttonName: "导出",
        buttonStyle: "warning",
        hasPermi: ['alarm:page:export'],
        className: 'exportBtn',
        buttonIcon: "Upload",
        exp: item => handleExport(item)
      }]
    });
    let queryParams = reactive({
      pageNum: 1,
      // 当前页数
      pageSize: 10,
      //  每页数目
      lastOccurEndTime: '',
      //lastOccurEndTime,
      lastOccurStartTime: '',
      // lastOccurStartTime,
      dateRange: [],
      // [lastOccurStartTime, lastOccurEndTime],
      deviceCode: "",
      menuTypes: [],
      tenantId: null,
      closeType: null,
      // 0自动/1人工
      clearStartTime: "",
      // 消缺开始时间
      clearEndTime: "",
      // 消缺结束时间
      clearDateRange: [] // 消缺时间范围
    });
    const searchFormData = ref([{
      prop: "deviceCode",
      label: "设备编号",
      placeholder: "请输入设备编号",
      type: "text",
      span: 4
    },
    // {
    //   prop: "menuTypes",
    //   label: "设备类型",
    //   placeholder: "请选择设备类型",
    //   type: "list",
    //   span: 4,
    //   isSelect: false,
    //   filterable: true,
    //   multiple: true,
    //   options: [
    //     { label: "执行器", value: 1 },
    //     { label: "场站泄漏", value: 2 },
    //     { label: "阀井泄漏", value: 3 },
    //     { label: "管钉泄漏", value: 4 },
    //     { label: "管桩泄漏", value: 5 },
    //     { label: "压力监测", value: 6 },
    //     { label: "工商业报警", value: 7 },
    //   ],
    //   props: { label: 'label', value: 'value' },
    // },
    {
      prop: "closeType",
      label: "处理结果",
      placeholder: "请选择处理结果",
      type: "list",
      span: 4,
      isSelect: false,
      filterable: true,
      multiple: false,
      options: [{
        label: "自动消缺",
        value: 0
      }, {
        label: "人工处理",
        value: 1
      }],
      props: {
        label: 'label',
        value: 'value'
      }
    }, {
      prop: "dateRange",
      type: "datetimerange",
      label: "最后告警时间",
      span: 2,
      pickerOptions: {
        disabledDate: time => {
          // return time.getTime() > Date.now() || time.getTime() < Date.now()
          return time.getTime() > Date.now();
        }
      },
      change: val => {
        if (!val) {
          queryParams.lastOccurStartTime = "";
          queryParams.lastOccurEndTime = "";
        } else {
          queryParams.lastOccurStartTime = val[0];
          queryParams.lastOccurEndTime = val[1];
        }
      }
    }, {
      prop: "clearDateRange",
      type: "datetimerange",
      label: "消缺时间",
      span: 2,
      pickerOptions: {
        disabledDate: time => {
          return time.getTime() > Date.now();
        }
      },
      change: val => {
        if (!val) {
          queryParams.clearStartTime = "";
          queryParams.clearEndTime = "";
        } else {
          queryParams.clearStartTime = val[0];
          queryParams.clearEndTime = val[1];
        }
      }
    }]);
    let loading = ref(false);
    const getList = () => {
      loading.value = true;
      const params = {
        ...queryParams
      };
      // params.menuTypes = params.menuTypes?params.menuTypes.join(","):'';
      params.deviceUuid = params.deviceCode;
      delete params.dateRange;
      delete params.clearDateRange;
      weChatrequest({
        url: '/api/v1/alarm/ledger/history',
        method: 'post',
        data: params
      }).then(res => {
        if (res.code == 0) {
          state.tableData.rows = res.data.records;
          state.tableData.total = res.data.total;
        }
      }).finally(() => {
        loading.value = false;
      });
    };
    const resetQuery = () => {
      queryParams.pageNum = 1; // 当前页数
      queryParams.pageSize = 10; //  每页数目
      // queryParams.lastOccurEndTime = lastOccurEndTime
      // queryParams.lastOccurStartTime = lastOccurStartTime
      // queryParams.dateRange = [lastOccurStartTime, lastOccurEndTime]
      queryParams.dateRange = [];
      queryParams.deviceCode = "";
      queryParams.menuTypes = [];
      queryParams.tenantId = null;
      queryParams.closeType = null;
      queryParams.clearStartTime = "";
      queryParams.clearEndTime = "";
      queryParams.clearDateRange = [];
      getList();
    };
    const formHandle = [{
      label: "搜索",
      type: "primary",
      icon: "el-icon-search",
      class: "btn-liquid",
      handle: () => getList()
    }, {
      label: "重置",
      icon: "el-icon-refresh",
      class: "commonDarkBtn",
      handle: () => resetQuery()
    }];
    const tableHeader = [{
      prop: "deviceCode",
      label: "设备编号",
      fixed: false,
      type: "text"
    }, {
      prop: "alarmContent",
      label: "告警内容",
      fixed: false,
      type: "text"
    },
    // {
    //   prop: "alarmTime",
    //   label: "告警时间",
    //   fixed: false,
    //   type: "text",
    // },
    // {
    //   prop: "menuType",
    //   label: "设备类型",
    //   statusList: [{
    //     value: 1,
    //     label: "执行器",
    //   },{
    //     value: 2,
    //     label: "场站泄漏",
    //   },
    //   {
    //     value: 3,
    //     label: "阀井泄漏",
    //   },
    //   {
    //     value: 4,
    //     label: "管钉泄漏",
    //   },
    //   {
    //     value: 5,
    //     label: "管桩泄漏",
    //   }, {
    //     value: 6,
    //     label: "压力监测",
    //   }, {
    //     value: 7,
    //     label: "工商业报警",
    //   },
    //   ],
    // },
    {
      prop: "firstAlarmTime",
      label: "初次告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "lastOccurTime",
      label: "最后告警时间",
      fixed: false,
      type: "text"
    }, {
      prop: "occurCnt",
      label: "告警次数",
      fixed: false,
      type: "text"
    }, {
      prop: "clearTime",
      label: "告警消缺时间",
      fixed: false,
      type: "text"
    }, {
      prop: "durationDesc",
      label: "告警持续时间",
      fixed: false,
      type: "text"
    }, {
      prop: "closeType",
      label: "处理结果",
      fixed: false,
      statusList: [{
        value: 0,
        label: "自动消缺"
      }, {
        value: 1,
        label: "人工处理"
      }],
      type: "text"
    }, {
      prop: "operation",
      label: "处理记录",
      width: "80px",
      fixed: 'right',
      operation: [{
        name: '处理记录',
        clickFun: row => viewHistoryRecords(row),
        hasPermi: ["alarm:history:records"],
        hideHandle(row) {
          return row.closeType != 1;
        }
      }, {
        name: '--',
        clickFun: row => viewHistoryRecords(row),
        hasPermi: [],
        hideHandle(row) {
          return row.closeType == 1;
        },
        disabledHandle(row) {
          return row.closeType != 1;
        }
      }]
    }
    // {
    //   prop: "deviceAddress",
    //   label: "安装位置",
    //   fixed: false,
    //   type: "text",
    // }
    ];
    const handleNodeClick = params => {
      nextTick(() => {
        state.defaultCheckNode = [params];
      });
      state.currentNodeKey = params.id;
      getList();
    };
    // 查看处理记录
    const viewHistoryRecords = async row => {
      state.historyRecords = [];
      if (row.id) {
        const response = await weChatrequest({
          url: '/api/v1/alarm/resolution/list',
          method: 'get',
          params: {
            alarmId: row.id,
            alarmType: 1 // 0-实时告警；1-历史告警
          }
        });
        if (response.code == 0) {
          state.historyRecords = response.data || [];
        } else {
          ElMessage.error(response.msg || '获取处理记录失败');
        }
      }
      state.openHistoryRecords = true;
    };
    // 关闭处理记录弹窗
    const closeHistoryRecords = () => {
      state.openHistoryRecords = false;
      state.historyRecords = [];
    };
    const handleExport = function () {
      ElMessageBox.close();
      ElMessageBox.confirm('是否确认导出数据?', "导出", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        let params = {
          ...queryParams
        };
        delete params.dateRange;
        delete params.clearDateRange;
        params.deviceUuid = params.deviceCode;
        weChatrequest({
          url: '/api/v1/alarm/ledger/history/export',
          method: 'post',
          data: params,
          responseType: 'blob'
        }).then(res => {
          if (res.status === 200) {
            let fileName = decodeURI(res.headers["content-disposition"].split("utf-8''")[1]);
            download(res.data, fileName);
          }
        }).catch(() => {});
      });
    };
    onMounted(async () => {
      state.loading = true;
      weChatrequest({
        url: '/api/v1/sysArea/findTree',
        method: "get"
      }).then(res => {
        state.treeData = [res.data];
        if (state.treeData[0]?.children) {
          state.defaultExendNode = state.treeData[0].children[0].id;
        }
        state.loading = false;
      }).catch(() => {
        state.loading = false;
      });
    });
    return (_ctx, _cache) => {
      const _component_commonForm = _resolveComponent("commonForm");
      const _component_Iconfont = _resolveComponent("Iconfont");
      const _component_commonTable = _resolveComponent("commonTable");
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_commonDrawer = _resolveComponent("commonDrawer");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createVNode(_component_commonForm, {
        form: _unref(queryParams),
        formData: searchFormData.value,
        showLabel: true,
        formHandle: formHandle
      }, null, 8, ["form", "formData"])])]), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_Iconfont, {
        name: "zhihui-guanwangxinxi",
        class: "table-title-icon"
      }), _hoisted_7])]), _withDirectives(_createVNode(_component_commonTable, {
        size: "medium",
        ref: "tableContainer",
        style: {
          "clear": "both"
        },
        hasStripe: false,
        hasSelect: false,
        tableData: state.tableData,
        tableHeaderName: "monitorAlarmRealTime",
        multipleSelection: state.multipleSelection,
        "onUpdate:multipleSelection": _cache[0] || (_cache[0] = $event => state.multipleSelection = $event),
        tableHeader: tableHeader,
        queryParams: _unref(queryParams),
        onGetList: getList
      }, null, 8, ["tableData", "multipleSelection", "queryParams"]), [[_directive_loading, _unref(loading)]])]), _createVNode(_component_commonDrawer, {
        modelValue: state.openHistoryRecords,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => state.openHistoryRecords = $event),
        size: "550px",
        title: "处理记录",
        "close-on-click-modal": false,
        onClose: closeHistoryRecords
      }, {
        default: _withCtx(() => [_createElementVNode("div", null, [state.historyRecords.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.historyRecords, (record, index) => {
          return _openBlock(), _createElementBlock("div", {
            key: record.id,
            class: "record-card"
          }, [_createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, " 处理时间：" + _toDisplayString(record.createTime), 1), _createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("span", _hoisted_14, _toDisplayString(record.createName || '-'), 1)])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", _hoisted_18, _toDisplayString(record.treatResultName), 1)]), _createElementVNode("div", _hoisted_19, [_hoisted_20, _createElementVNode("span", _hoisted_21, _toDisplayString(record.treatOpinion), 1)]), record.imgUrl ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_hoisted_23, _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.imgUrl.split(','), (img, imgIndex) => {
            return _openBlock(), _createBlock(_component_el_image, {
              key: imgIndex,
              src: getImgUrl(img),
              "zoom-rate": 1.2,
              "preview-src-list": record.imgUrl.split(',').map(url => getImgUrl(url)),
              "initial-index": imgIndex,
              fit: "cover",
              class: "preview-img",
              "preview-teleported": ""
            }, null, 8, ["src", "zoom-rate", "preview-src-list", "initial-index"]);
          }), 128))])])) : _createCommentVNode("", true)])]);
        }), 128))])])) : (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_empty, {
          description: "暂无处理记录"
        })]))])]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }
});